module.exports = __webpack_public_path__ + "img/email-confirmation.517a6227.svg";